import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, Alert } from '@mui/material';
import { auth } from '../firebase';

function RequireAuth({ children, adminRequired = false }) {
  const user = auth.currentUser;

  if (!user) {
    return (
      <Box p={3}>
        <Alert severity="warning">
          Bu sayfayı görüntülemek için giriş yapmanız gerekmektedir. Lütfen giriş yapın.
        </Alert>
      </Box>
    );
  }

  if (adminRequired && !user.isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default RequireAuth; 